import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  TextField,
  InputLabel,
  Checkbox,
  Input,
  Button,
  Autocomplete,
} from "@mui/material";
import { makeStyles } from "@material-ui/core";
import { listRecordCategories } from "../actions/VivoFinanceActions";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import styles from "assets/jss/vivoleo-react-kit/views/componentsSections/addRecordScreenStyle";

const Row = function (props) {
  const { checked, value, onChange, onChecked } = props;
  return (
    <div>
      <Checkbox checked={checked} onChange={onChecked} />
      <Input type="text" value={value} onChange={onChange} />
    </div>
  );
};

const useStyles = makeStyles(styles);

export default function AddRemoveCat(props) {
  const classes = useStyles();
  const [addedCategories, setAddedCategories] = useState([]);
  const [rows, setRows] = useState([]);
  const { originalCategories } = useParams();
  /*
  const initRowsFunction = () => {
    const initRows = [];
    for (let i = 0; i < originalCategories.length; i++) {
      const initNewRow = { value: originalCategories[i], checked: false };
      initRows.push(initNewRow);
    }
    console.log("initRows: " + initRows);
    setRows(initRows);
  };
*/
  const recordCategoryList = useSelector((state) => state.recordCategoryList);
  const {
    loading: loadingCategories,
    error: errorCategories,
    summary: recordcategories,
  } = recordCategoryList;
  //const dispatch1 = useDispatch();
  const dispatch2 = useDispatch();

  useEffect(() => {
    //dispatch1(initRowsFunction());
    dispatch2(listRecordCategories());
  }, [rows]);
  const addCategory = (newcategory) => {
    console.log("newcategory:" + newcategory);
    if (
      newcategory !== null &&
      newcategory !== "" &&
      !addedCategories.includes(newcategory)
    ) {
      //setAddedCategories([...addedCategories, newcategory]);
      addedCategories.push(newcategory);
      console.log("addedCategories:" + addedCategories);
      const thisrows = [...rows, { value: newcategory, checked: false }];
      setRows(thisrows);
      //addCategoryID(newcategory);
    }
  };

  const updateValue = (e, index) => {
    const thisrows = [...rows]; // copy array because we don't want to mutate the previous one
    thisrows[index].value = e.target.value;
    setRows(thisrows);
  };

  const onChecked = (index) => {
    const thisrows = [...rows]; // copy array because we don't want to mutate the previous one
    thisrows[index].checked = !thisrows[index].checked;
    setRows(thisrows);
  };

  const deleteRows = () => {
    setRows(rows.filter((e) => !e.checked));
    //setAddedCategories([]);
    const newvalue = [];
    rows.forEach((x) => {
      newvalue.push(x.value);
    });
    console.log("newvalue:" + newvalue);
    setAddedCategories(newvalue);
    //confirmSelection(addedCategories);
    console.log("rows-values:" + rows);
    console.log("addedCategories:" + addedCategories);
  };

  const updateTaxrate = () => {
    console.log("rows-values:" + rows);
    const newvalue = [];
    rows.forEach((x) => {
      newvalue.push(x.value);
    });
    //console.log("newvalue:" + newvalue);
    const newvalueset = [...new Set(newvalue)];
    setAddedCategories(newvalueset);
    //setAddedCategories((addedCategories) => [...new Set(addedCategories)]);
    confirmSelection(newvalueset, true);
  };

  const confirmSelection = (selectedcategory, onConfirmed) => {
    props.confirmedCategory(selectedcategory, onConfirmed);
  };

  return (
    <>
      <div className={classes.space30}> </div>
      {loadingCategories ? (
        <LoadingBox></LoadingBox>
      ) : errorCategories ? (
        <MessageBox variant="danger">{errorCategories}</MessageBox>
      ) : (
        <Autocomplete
          id="category"
          freeSolo
          options={recordcategories.categories.map((x) => x.category)}
          sx={{ width: 300 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Category "
              defaultValue="Select one Category or input new Category "
              helperText="Select one Category or input new Category "
              variant="standard"
              required
            />
          )}
          // onChange={(e) => setDescription(value)}
          onChange={(event, newValue) => {
            addCategory(newValue);
          }}
        />
      )}
      <div>
        {rows && rows.length > 0 ? (
          <>
            {rows.map((row, index) => {
              return (
                <Row
                  key={index}
                  value={row.value}
                  checked={row.checked}
                  onChange={(e) => updateValue(e, index)}
                  onChecked={() => onChecked(index)}
                />
              );
            })}
            <div className={classes.space30}> </div>
            <Button onClick={deleteRows} variant="outlined" size="small">
              Clear Selected Catagory
            </Button>
            <div className={classes.space30}> </div>
          </>
        ) : (
          <div className={classes.space30}> </div>
        )}
      </div>
      <Button
        onClick={() => {
          updateTaxrate();
        }}
        variant="outlined"
        size="small"
      >
        Confirm Selected Category
      </Button>
    </>
  );
}
